import React, { Component } from 'react';
import SwipeableViews from 'react-swipeable-views';

class Steps extends Component {

    render() {
        const { activeStep, handleStepChange, rootStyle, className } = this.props;
        return (
            <SwipeableViews
                axis='x'
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
                slideClassName='stolo-carousel-slide'
                className={className}
            >
                {this.props.children}
            </SwipeableViews>
        );
    }
}

export default Steps;



// WEBPACK FOOTER //
// ./src/components/stepper/Steps.js